/**
 * Blog Posts List Custom - Handles tab filtering for blog articles
 */

class BlogCustomFilter {
  constructor() {
    this.tabs = document.querySelectorAll(".blog-tab");
    this.blogGroups = document.querySelectorAll(".blog-group");
    this.activeTab = "all";

    this.init();
  }

  init() {
    if (!this.tabs.length) return;

    // Add click event listeners to tabs
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", (e) => this.handleTabClick(e));
    });
  }

  handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const tabValue = clickedTab.getAttribute("data-tab");

    if (this.activeTab === tabValue) return;

    this.activeTab = tabValue;
    this.updateTabs(clickedTab);
    this.filterBlogs(tabValue);
  }

  updateTabs(activeTab) {
    // Remove active state from all tabs
    this.tabs.forEach((tab) => {
      tab.classList.remove("border-darkOrange");
      tab.classList.add("border-transparent");
      tab.setAttribute("aria-pressed", "false");
    });

    // Add active state to clicked tab
    activeTab.classList.remove("border-transparent");
    activeTab.classList.add("border-darkOrange");
    activeTab.setAttribute("aria-pressed", "true");
  }

  filterBlogs(tabValue) {
    this.blogGroups.forEach((group) => {
      const blogHandle = group.getAttribute("data-blog");

      if (tabValue === "all") {
        // Show all blogs
        group.style.display = "block";
        this.fadeIn(group);
      } else if (blogHandle === tabValue) {
        // Show matching blog
        group.style.display = "block";
        this.fadeIn(group);
      } else {
        // Hide non-matching blogs
        this.fadeOut(group);
      }
    });
  }

  fadeIn(element) {
    element.style.opacity = "0";
    element.style.display = "block";

    setTimeout(() => {
      element.style.transition = "opacity 300ms ease-in-out";
      element.style.opacity = "1";
    }, 10);
  }

  fadeOut(element) {
    element.style.transition = "opacity 300ms ease-in-out";
    element.style.opacity = "0";

    setTimeout(() => {
      element.style.display = "none";
    }, 300);
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new BlogCustomFilter();
  });
} else {
  new BlogCustomFilter();
}

// Re-initialize on Shopify section editor updates
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    new BlogCustomFilter();
  });
}
